import { useState, useCallback } from 'react';
import NewsFeed from './NewsFeed';
import SentimentPriceChart from './SentimentPriceChart';
import SentimentHeatmap from './SentimentHeatmap';
import AlertSystem from './AlertSystem';

export default function DashboardTab() {
  const [chartKey, setChartKey] = useState(0);
  const [alerts, setAlerts] = useState([]);

  const handleNewArticle = useCallback(() => setChartKey(k => k + 1), []);
  const handleAlerts = useCallback((a) => setAlerts(a), []);

  return (
    <div className="p-5 space-y-5">
      {/* Top: feed + chart */}
      <div className="grid grid-cols-1 lg:grid-cols-[30%_1fr] gap-5 h-[700px]">
        <div className="min-h-[400px] lg:min-h-0 lg:h-full">
          <NewsFeed onNewArticle={handleNewArticle} onAlerts={handleAlerts} />
        </div>
        <div className="lg:h-full">
          <SentimentPriceChart key={chartKey} />
        </div>
      </div>

      {/* Bottom: heatmap */}
      <SentimentHeatmap onSelectAsset={sym => console.log('Selected:', sym)} />

      {/* Bottom: alert bar */}
      <AlertSystem alerts={alerts} />
    </div>
  );
}
